import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "login-message" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-18px font-bold" }, [
        /*#__PURE__*/ _createTextVNode("これから先は"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("ログイン／新規登録が必要です")
    ])
], -1);
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-2 tablet:mb-8 text-16px tablet:text-22px font-bold" }, "ログイン後に全文お読みいただけます", -1);
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-2 tablet:mb-4 text-engate text-14px tablet:text-22px font-bold" }, "まずは無料で新規登録", -1);
import { computed } from 'vue';
import { useAuthStore, useProfileStore } from "../../store";
import { useAuthorizationStore } from "../../store/authorization";
import { sendSigninPage } from '../../utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PostBlock',
    props: {
        post: { type: String, required: false },
        limitedPost: { type: String, required: false },
        lastSection: { type: String, required: false },
        isLimited: { type: Boolean, required: false },
    },
    setup: function (__props) {
        var props = __props;
        var authStore = useAuthStore();
        var profileStore = useProfileStore();
        var authorize = useAuthorizationStore();
        var postHtml = computed(function () {
            return (!authStore.isAuth && props.isLimited) ? props.limitedPost : props.post;
        });
        var moveSigninPage = function (event) {
            event.preventDefault();
            sendSigninPage(location, window.scrollY);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("article", { innerHTML: postHtml.value }, null, 8, _hoisted_1),
                (!_unref(authStore).isAuth && __props.isLimited)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_2,
                        _createElementVNode("section", {
                            class: "article-section last-section",
                            innerHTML: __props.lastSection
                        }, null, 8, _hoisted_3),
                        _createElementVNode("div", { class: "login-box mt-2 mb-42px" }, [
                            _hoisted_4,
                            _hoisted_5,
                            _createElementVNode("a", {
                                href: "/signin/",
                                class: "login-btn",
                                onClick: moveSigninPage
                            }, " ログイン／新規登録 ")
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
